export const SCHEDULING_CONSTANTS = {
  MINUTES_TO_ADD_FOR_IMMEDIATE_SENDING: 5,
  MIN_HOUR: 8,
  MAX_HOUR: 19,
  DATE_FORMAT: "YYYY-MM-DDTHH:mm:ss",
  DISPLAY_DATE_FORMAT: "DD/MM/YYYY HH:mm",
  DISPLAY_DATE_ONLY_FORMAT: "DD/MM/YYYY",
  DAY_START_TIME: "00:00:00",
} as const;

export const HOUR_OPTIONS = [
  "08:00",
  "09:00",
  "10:00",
  "11:00",
  "12:00",
  "13:00",
  "14:00",
  "15:00",
  "16:00",
  "17:00",
  "18:00",
  "19:00",
] as const;

export const WEEK_DAYS = [
  { key: "domingo", label: "Dom", index: 0 },
  { key: "segunda", label: "Seg", index: 1 },
  { key: "terca", label: "Ter", index: 2 },
  { key: "quarta", label: "Qua", index: 3 },
  { key: "quinta", label: "Qui", index: 4 },
  { key: "sexta", label: "Sex", index: 5 },
  { key: "sabado", label: "Sáb", index: 6 },
] as const;

export const DATE_TIME_REGEX = /^[0-2][0-9]:[0-5][0-9]$/;
